var _rect, _g, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacilityLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 90,
    height: 90,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3911 48.948V72.094L57.3641 67.515L58.3631 67.098L69.3351 62.519V39.374L46.3911 48.948ZM52.0671 69.513V57.781L57.3641 55.572V67.303L52.0671 69.513ZM63.6601 64.675L58.3631 66.885V55.154L63.6601 52.944V64.675Z",
    fill: "#08979C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4141 62.765L45.3921 72.1V48.951L22.4141 39.616V62.765ZM42.5651 65.6L37.1921 63.417V55.718L42.5651 57.901V65.6ZM36.1931 63.011L31.0731 60.931V53.231L36.1931 55.312V63.011ZM25.2411 50.863L30.0731 52.826V60.526L25.2411 58.562V50.863Z",
    fill: "#08979C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3909 20.369C39.9539 20.369 34.7349 25.588 34.7349 32.025C34.7349 38.462 39.9539 43.681 46.3909 43.681C52.8289 43.681 58.0469 38.462 58.0469 32.025C58.0469 25.588 52.8289 20.369 46.3909 20.369ZM53.7069 34.099H48.4639V39.341H44.3189V34.099H39.0759V29.952H44.3189V24.71H48.4639V29.952H53.7069V34.099Z",
    fill: "#08979C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1321 35.248C57.6931 40.952 52.5421 45.18 46.3911 45.18C40.1601 45.18 34.9531 40.843 33.5941 35.027L23.2871 38.892L45.8901 48.074L68.4641 38.655L59.1321 35.248Z",
    fill: "#08979C"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 90,
    height: 90,
    stroke: "#E8E8E8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 53,
    fill: "white",
    transform: "translate(21 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityLogo);
export default __webpack_public_path__ + "static/media/facility-logo.d85d7eb8a6f796e43d1339ae0f0b3c73.svg";
export { ForwardRef as ReactComponent };